import { GridScrollParams } from '@mui/x-data-grid-premium'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'
import debounce from 'lodash/debounce'
import { RefObject, useEffect, useState } from 'react'

export function useHasScrolledHorizontally(apiRef: RefObject<GridApiPremium>): boolean {
  const [hasScrolledHorizontally, setHasScrolledHorizontally] = useState(false)

  const subscribeEvent = apiRef.current?.subscribeEvent
  useEffect(() => {
    if (!subscribeEvent) return

    const handleScroll = debounce((params: GridScrollParams) => setHasScrolledHorizontally(params.left > 0))

    return subscribeEvent('scrollPositionChange', handleScroll)
  }, [subscribeEvent])

  return hasScrolledHorizontally
}
